import { styled } from '@slal/ui';
import { Col, Row, Container } from '@slal/ui/layout';

export const StyledCol = styled(Col)``;

export const StyledRow = styled(Row)``;

export const StyledContainer = styled(Container)`
    margin: 0;
    display: block;
    max-width: 1400px;
    min-width: 100%;
    padding: ${({ theme }) => theme.space[5]};
`;
